import { ExternalDomContent } from '@ff-os/shared-react/hooks/useExternalRender';
import { DisplayMode, Language } from './slices/globalSlice';

export namespace IDT {

    export type Options = {
        readonly language: Language;
        readonly mode: DisplayMode;
        readonly open?: OpenOptions;
        readonly containers: Containers;
        readonly events: Events;
        readonly pricing: Pricing;
    };

    export type HydrateOptions = {
        readonly open?: OpenOptions;
        readonly containers: Containers;
        readonly events: Events;
        readonly pricing: Pricing;
    };

    export type OpenOptions = {
        readonly authorize: string;
        readonly refresh: RefreshAuthorization;
    };

    export type Containers = ContainersWithModal | ContainersWithDesigner;

    export type Events = {
        readonly load: (event: LoadEvent) => void;
        readonly focus: (event: FocusEvent) => void;
        readonly pricing: (event: PricingEvent) => void;
        readonly order: (event: OrderEvent) => Promise<void> | void;
    };

    export type RefreshAuthorization = (projectId: string) => Promise<string>;

    export type Event<name extends string> = {
        name: name;
    };

    export type LoadEvent = Event<'load'>;

    export type FocusEvent = Event<'focus'>;

    export type PricingEvent = Event<'pricing'> & TotalPriceRequest;

    export type OrderEvent = Event<'order'> & {
        quantity: number;
        projectId: string;
        snapshotId: string;
    };

    export type Pricing = {
        readonly total: (request: TotalPriceRequest) => ExternalDomContent;
        readonly from: (request: FromPriceRequest) => ExternalDomContent;
    };

    export type FromPriceRequest = {
        sku: string;
        attributes?: Record<string, any>;
    };

    export type TotalPriceRequest = {
        items: {
            sku: string;
            quantity: number;
            attributes?: Record<string, any>;
        }[];
    };
}

type ContainersWithModal = {
    readonly modal: HTMLElement;
    readonly preview?: HTMLElement;
};

type ContainersWithDesigner = {
    readonly designer: HTMLElement;
    readonly preview?: HTMLElement;
};

export const usesDesignerContainer = (
    containers: IDT.Containers
): containers is ContainersWithDesigner => {
    return 'designer' in containers;
};

export const usesModalContainer = (
    containers: IDT.Containers
): containers is ContainersWithModal => {
    return 'modal' in containers;
};